import { t } from '../../../locale';
import { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  message?: ValidationMessage;
}

export default function email(config: Config = {}): ValidationRule {
  return {
    name: 'email',
    validator(value) {
      return !isDefined(value) || (typeof value === 'string' && /^\S+@\S+\.\S+$/.test(value));
    },
    message: config.message || t('ll.validation.email'),
  };
}
